import * as Mod1 from "./discourse/components/reports/activity-calendar";
import * as Mod2 from "./discourse/components/reports/ai-usage";
import * as Mod3 from "./discourse/components/reports/assignments";
import * as Mod4 from "./discourse/components/reports/best-posts";
import * as Mod5 from "./discourse/components/reports/best-topics";
import * as Mod6 from "./discourse/components/reports/chat-usage";
import * as Mod7 from "./discourse/components/reports/favorite-gifs";
import * as Mod8 from "./discourse/components/reports/fbff";
import * as Mod9 from "./discourse/components/reports/header";
import * as Mod10 from "./discourse/components/reports/invites";
import * as Mod11 from "./discourse/components/reports/most-viewed-categories";
import * as Mod12 from "./discourse/components/reports/most-viewed-tags";
import * as Mod13 from "./discourse/components/reports/new-user-interactions";
import * as Mod14 from "./discourse/components/reports/reactions";
import * as Mod15 from "./discourse/components/reports/reading-time";
import * as Mod16 from "./discourse/components/reports/time-of-day-activity";
import * as Mod17 from "./discourse/components/reports/top-words";
import * as Mod18 from "./discourse/components/reports/top-words/word-card";
import * as Mod19 from "./discourse/components/reports/writing-analysis";
import * as Mod20 from "./discourse/components/rewind";
import * as Mod21 from "./discourse/connectors/after-header-panel/rewind-decoration.gjs";
import * as Mod22 from "./discourse/connectors/before-panel-body/rewind-callout.gjs";
import * as Mod23 from "./discourse/connectors/user-activity-bottom/rewind-tab.gjs";
import * as Mod24 from "./discourse/connectors/user-preferences-nav/rewind-preferences.gjs";
import * as Mod25 from "./discourse/controllers/preferences/rewind";
import * as Mod26 from "./discourse/initializers/rewind-setup";
import * as Mod27 from "./discourse/lib/rewind-i18n";
import * as Mod28 from "./discourse/pre-initializers/rewind-user-options";
import * as Mod29 from "./discourse/preferences-rewind-route-map";
import * as Mod30 from "./discourse/rewind-route-map";
import * as Mod31 from "./discourse/routes/user-activity/rewind";
import * as Mod32 from "./discourse/services/rewind";
import * as Mod33 from "./discourse/templates/preferences/rewind";
import * as Mod34 from "./discourse/templates/user/rewind";
const compatModules = {
  "discourse/components/reports/activity-calendar": Mod1,
  "discourse/components/reports/ai-usage": Mod2,
  "discourse/components/reports/assignments": Mod3,
  "discourse/components/reports/best-posts": Mod4,
  "discourse/components/reports/best-topics": Mod5,
  "discourse/components/reports/chat-usage": Mod6,
  "discourse/components/reports/favorite-gifs": Mod7,
  "discourse/components/reports/fbff": Mod8,
  "discourse/components/reports/header": Mod9,
  "discourse/components/reports/invites": Mod10,
  "discourse/components/reports/most-viewed-categories": Mod11,
  "discourse/components/reports/most-viewed-tags": Mod12,
  "discourse/components/reports/new-user-interactions": Mod13,
  "discourse/components/reports/reactions": Mod14,
  "discourse/components/reports/reading-time": Mod15,
  "discourse/components/reports/time-of-day-activity": Mod16,
  "discourse/components/reports/top-words": Mod17,
  "discourse/components/reports/top-words/word-card": Mod18,
  "discourse/components/reports/writing-analysis": Mod19,
  "discourse/components/rewind": Mod20,
  "discourse/connectors/after-header-panel/rewind-decoration": Mod21,
  "discourse/connectors/before-panel-body/rewind-callout": Mod22,
  "discourse/connectors/user-activity-bottom/rewind-tab": Mod23,
  "discourse/connectors/user-preferences-nav/rewind-preferences": Mod24,
  "discourse/controllers/preferences/rewind": Mod25,
  "discourse/initializers/rewind-setup": Mod26,
  "discourse/lib/rewind-i18n": Mod27,
  "discourse/pre-initializers/rewind-user-options": Mod28,
  "discourse/preferences-rewind-route-map": Mod29,
  "discourse/rewind-route-map": Mod30,
  "discourse/routes/user-activity/rewind": Mod31,
  "discourse/services/rewind": Mod32,
  "discourse/templates/preferences/rewind": Mod33,
  "discourse/templates/user/rewind": Mod34,
};
export { compatModules };
export default compatModules;
